import { Component, OnInit } from '@angular/core';

@Component({
  selector: 'app-service',
  templateUrl: './Solutions.component.html',
  styleUrls: ['./Solutions.component.css']
})
export class SolutionsComponent implements OnInit {

  constructor() { }

  ngOnInit(): void {
  }

}
